<template>
  <Datepicker
    v-model="date"
    placeholder="Select Data"
    :enableTimePicker="false"
    :format="format"
    :locale="language.code"
    autoApply
  ></Datepicker>
</template>

<script>
import { ref, computed } from "vue";
import Datepicker from "vue3-date-time-picker";
import store from "@/store";

export default {
  components: { Datepicker },
  setup() {
    const date = ref();

    const language = computed(() => store.getters.getLanguage());

    // In case of a range picker, you'll receive [Date, Date]
    const format = (date) => {
      const day = { start: date[0].getDate(), end: date[1].getDate() };
      const month = {
        start: date[0].getMonth() + 1,
        end: date[1].getMonth() + 1,
      };
      const year = { start: date[0].getFullYear(), end: date[1].getFullYear() };

      return `${day.start}/${month.start}/${year.start} - ${day.end}/${month.end}/${year.end}`;
    };

    return {
      date,
      format,
      language,
    };
  },
};
</script>